import React from "react";
import Header from "../pages/Header";
import Footer from "../pages/Footer";
import topback from "../images/beetitle.png";
import P8 from "../images/eight.webp";
function Csca(){
    return(
        <>
        <Header />
        <section class="content-section title-top" style={{ backgroundImage: `url(${topback})` }}>
  <div class="pattern-overlay">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 title-heading">
        <h2>CSCA 2023-24</h2>  
	   </div>
      </div>
    </div>
  </div>
</section>
{/* <!-- section --> */}
<div class="section margin-top_50">
        <div class="container mb-5 pb-5">
            <div class="row">
            <div class="col-md-4">
                    <div class="full mt-5">
                        <img src={P8} alt="#" />
                    </div>
                </div>
                <div class="col-md-8 layout_padding_2">
                    <div class="full">
						<div class="full">
						  <p>CSCA for the  session 2023-2024 on the basis of academic merit and nominations in  r/o SDWG GOVT.COLLEGE BEETAN..The detail of the CSCA office bearers is as under:<br />

              List of office Bearers CSCA SDWG GOVT.College Beetan for the session 2023-2024</p>
						</div>
            <table class="table">
    <thead>
      <tr>
        <th>Post</th>
        <th>Name</th>
        <th>Roll No.</th>
        <th>Class</th>
        <th>Category</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>President</td>
        <td>Anuradha</td>
        <td>113</td>
        <td>B.A.3rd Yea</td>
        <td>Academic Merit</td>
      </tr>
      <tr>
        <td>Vice President</td>
        <td>Sanjana</td>
        <td>549</td>
        <td>B.A.2ND Year</td>
        <td>Academic Merit</td>
      </tr>
      <tr>
        <td>Secretary</td>
        <td>Neeraj Jaswal</td>
        <td>23bcm001</td>
        <td>B.Com 1st Year</td>
        <td>Academic Merit</td>
      </tr>
      <tr>
        <td>Joint Secretary </td>
        <td>Diya</td>
        <td>23HIS027</td>
        <td>B.A.1st Year </td>
        <td>Academic Merit</td>
      </tr>
    </tbody>
  </table>
  <h6>Committee Members:</h6>

<p>1. Prof. Gurdev Singh</p> 
<p>2. Dr .Daleep Bali</p>
<p>3. Prof .Gurmel Singh</p>

<div class="full">
                        
                        <div className="about-principal">
                        <p><strong>Dr. Sunita Goyal</strong></p>
                        <p><strong>Principal SDWG Govt. College Beetan</strong></p>
                        <p><strong>Distt. Una H.P.</strong></p>
                        </div>
                    </div>
						
                    </div>
                </div>
            </div>
        </div>
    </div>
	{/* <!-- end section --> */}
  <Footer />
        </>
    );
}

export default Csca;